import { Col, Row } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useGlobalFilterContext } from "../../../../../../contexts/GlobalFilterProvider";
import query from "../../../../../../server/constants.api";
import useFetch from "../../../../../../server/useFetch";
import { isEmpty } from "../../../../../../utils/hooks/isEmpty";
import { Widget } from "../../../../Atomics/Widget";

const RadialBarText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & h3 {
        margin: 0;
    }
`;

export const LeftIncidentsWidgetsSingleClassComponent = ({ items, classes }) => {
    const { t } = useTranslation();
    const { subEntity } = useGlobalFilterContext();
    //Field Incidents
    const { data: mapFieldIncidents, refetch: refetchMapFieldIncidents, isFetching: mapFieldIncidentsIsFetching } = useFetch(
        `/incidents/field`, "mapFieldIncidents",
        {
            id: subEntity?.id,
            tenant: subEntity?.tenant,
            classes: classes?.map((item) => item.value).join(',')
        },
        false, null, query.middlewareCommandURL
    );

    useEffect(() => {
        if (subEntity) {
            refetchMapFieldIncidents();
        }
    }, [classes]);

    //Unassigned Incidents
    const { data: mapUnassignedIncidents, refetch: refetchMapUnassignedIncidents, isFetching: mapUnassignedIncidentsIsFetching } = useFetch(
        `/incidents/unassigned`, "mapUnassignedIncidents",
        {
            id: subEntity?.id,
            tenant: subEntity?.tenant,
            classes: classes?.map((item) => item.value).join(',')
        },
        false, null, query.middlewareCommandURL
    );

    useEffect(() => {
        if (subEntity) {
            refetchMapUnassignedIncidents();
        }
    }, [classes]);

    //Incidents last 6 hours
    const { data: last6HoursIncidents, refetch: refetchLast6HoursIncidents, isFetching: last6HoursIncidentsIsFetching } = useFetch(
        `/incidents/open/last/6/hours`, "Last6HoursIncidents",
        {
            id: subEntity?.id,
            tenant: subEntity?.tenant,
            classes: classes?.map((item) => item.value).join(',')
        },
        false, null, query.middlewareCommandURL
    );

    useEffect(() => {
        if (subEntity) {
            refetchLast6HoursIncidents();
        }
    }, [classes]);

    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={12}>
                    <Widget
                        data={{
                            background: "transparent",
                            title: null,
                            icon: null,
                            border: null,
                            background: 'white',
                            activeShadow: true,
                            charts: [
                                {
                                    chartType: "radialBarChartApex",
                                    height: '90px',
                                    isFetching: mapFieldIncidentsIsFetching,
                                    data: {
                                        series: mapFieldIncidents?.total ? [(mapFieldIncidents?.field * 100 / mapFieldIncidents?.total).toFixed(0)] : 0,
                                        // labels: 'Value',
                                        radialBar: {
                                            dataLabels: {
                                                // name: {
                                                //   fontSize: '22px',
                                                // },
                                                value: {
                                                    fontSize: '15px',
                                                    color: '#259ffb',
                                                    offsetY: -10,
                                                    fontWeight: '600',
                                                }
                                            },
                                            fill: {
                                                color: '#259ffb',
                                            }
                                        }
                                    },
                                },
                            ],
                        }}
                    >
                        {!mapFieldIncidentsIsFetching ?
                            <RadialBarText>
                                <span>{t("filed.Field Incidents")}</span>
                                <h3>{mapFieldIncidents?.field}</h3>
                            </RadialBarText>
                            : null}
                    </Widget>
                </Col>
                <Col span={12}>
                    <Widget
                        data={{
                            background: "transparent",
                            title: null,
                            icon: null,
                            border: null,
                            background: 'white',
                            activeShadow: true,
                            charts: [
                                {
                                    chartType: "radialBarChartApex",
                                    height: '90px',
                                    isFetching: mapUnassignedIncidentsIsFetching,
                                    data: {
                                        series: mapUnassignedIncidents?.total ? [(mapUnassignedIncidents?.unassigned * 100 / mapUnassignedIncidents?.total).toFixed(0)] : 0,
                                        // labels: 'Value',
                                        radialBar: {
                                            dataLabels: {
                                                // name: {
                                                //   fontSize: '22px',
                                                // },
                                                value: {
                                                    fontSize: '15px',
                                                    color: '#259ffb',
                                                    offsetY: -10,
                                                    fontWeight: '600',
                                                }
                                            },
                                            fill: {
                                                color: '#259ffb',
                                            }
                                        }
                                    },
                                },
                            ],
                        }}
                    >
                        {!mapUnassignedIncidentsIsFetching ?
                            <RadialBarText>
                                <span>{t("filed.Unassigned Incidents")}</span>
                                <h3>{mapUnassignedIncidents?.unassigned}</h3>
                            </RadialBarText>
                            : null}
                    </Widget>
                </Col>
            </Row>
            <Col span={24}>
                <Widget data={{
                    width: 'auto',
                    background: 'white',
                    title: t("field.Incidents in the Last 6 Hours"),
                    icon: 'Clipboard',
                    description: null,
                    tooltip: null,
                    activeShadow: true,
                    charts: [
                        {
                            chartType: 'heatmapChart',
                            width: '100%',
                            height: '150px',
                            chartId: 'heatmapChartOne',
                            isFetching: last6HoursIncidentsIsFetching,
                            data: last6HoursIncidents && !isEmpty(last6HoursIncidents?.groupedIncidents) ? getIncidentsInLastHours(last6HoursIncidents?.groupedIncidents, classes) : []
                        }
                    ]
                }} />
            </Col>
        </>
    )
};

//Para organizar os incidentes nas ultimas 6 horas
const getIncidentsInLastHours = (data, classes) => {
    const series = [];
    const selectedClass = classes[0].value;

    Object.entries(data).forEach(([priority, valuesByHour]) => {
        const values = [];
        !isEmpty(valuesByHour) ? Object.entries(valuesByHour).forEach(([hour, value]) => {
            values.push({
                x: hour,
                y: value?.[selectedClass] // Replace 'someProperty' with the actual property name you want from the value object
            });
        }) : null;

        series.push({
            name: priority.split('-')[1],
            data: values
        });
    });

    return {
        series: series,
        "yAxisLabel": "Priorities",
        "xAxisLabel": "Hours",
    };
};